var exports = {
  "z": "x93eb46d8--c84745--root",
};

module.exports = exports;
